import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled'
import Carousel from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';

const Container = styled.div`
    padding-top:10rem;
    padding-bottom:10rem;
    display:grid;
    grid-auto-flow:row;
    grid-gap:2rem;
    hr{
        margin-top:5rem;
        width:93.125rem;
        background-color:var(--color-red-200);
        border-radius: 2px;
    }
    @media (max-width: 500px){
        margin-left:0rem;
    }

    .BrainhubCarouselItem{
        justify-content: flex-start;
    }
`;
const HeaderContainer = styled.div`
    position:relative;
    display:flex;
    flex-direction:row;
    left:3.5rem;

    
    background-image:url(/client-reviews/side-wave.svg);
    background-repeat: no-repeat;
    background-position-x:right;
    

     /* img{
         justify-self: flex-end;
         padding-left:30rem;
        
     } */
    @media (max-width: 500px){
        width:50%;
        justify-content:flex-start;
       img{
           display:none;
       }
    }
`;
const Header = styled.h1`
    font-family: Inter,sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: var(--font-40);
    line-height: 8.75rem;
    color: var(--color-gray-700);

    @media (max-width: 500px){
        position: relative;
        left: -3rem;
        font-size: var(--font-28);
    }

    @media (max-width: 400px){
        font-size: var(--font-28);
    }
 
`;
const Review = styled.div`
    width:35rem;
    padding-left: 4rem;
    font-style: normal;
    font-weight: normal;
    font-size: var(--font-18);
    line-height: var(--space-32);
    color: #000000;
    @media (max-width: 500px){
        padding-left: 3rem;
        width:20rem;
    }

    p{
        width: 33.69rem;
        height: 8rem;

        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: var(--font-18);
        line-height: var(--space-32);


        color: #000000;
    }

    @media (max-width: 500px){
        width: 16rem;
        height: auto;
        overflow-x: hidden;
    }
`;
const VerticalContainer = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-gap: 2rem;
`;

const ReviewContainer = styled.div`
    position: relative;
    display:grid;
    grid-auto-flow:column;
    grid-gap:10rem;
`;
const ImageContainer = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    width:17rem;
`;
const Title = styled.div`
    position:relative;
    top:1rem;

    display:flex;
    justify-content:space-between;
    flex-direction:column;
    height:3rem;

    .title{
        font-family:Inter,sans-serif;
        font-weight:600;
        font-size:var(--font-20);
    }
    .location{
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 1rem;
        line-height: 1rem;

        color: #000000;
    }
   
`;
const Divider = styled.div`
    width: 74.75rem;
    height: 2px;
    left: 17.25rem;
    top: 282.5rem;

    background: linear-gradient(90deg, #D8DCDE 50%, rgba(240, 243, 244, 0) 114.59%);
    border-radius: 2px;
`;
const Quote = styled.img`
    position:relative;
    right:3rem;
    top:2rem;
`;
const NavigationContainer = styled.div`
    display:flex;
    flex-direction:row;
    width:6rem;
    justify-content: space-between;
`;
const ActiveNavigation = styled.img`
    position: absolute;
    top: 20.7rem;
    left: 3.2rem;
    display: flex;
    flex-direction: row;
    padding: var(--space-14);
    cursor:pointer;
    width: 2.75rem;
    height: 2.75rem;
    

    background-color: var(--color-white);

    border: 1px solid #EDF0F2;
    box-sizing: border-box;

    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.12);
    border-radius: 62.5rem;

    :hover{
        background-color:var(--color-gray-100);
    }
    
    
`;

const DisabledNavigation = styled.img`
    
    display: flex;
    flex-direction: row;
    padding: var(--space-14);
    position: absolute;
    top: 20.7rem;

    width: 2.75rem;
    height: 2.75rem;

    background: var(--color-gray-200);

    border: 1px solid #EDF0F2;
    box-sizing: border-box;

    border-radius: 62.5rem;
    
`;
function ClientReview() {

    let array =   [
        {
            title:'Dr. Kendra Miller',
            location: 'Kingston Public Hospital',
            quote: `Lorem ipsum dolor sit amet, consectetur 
            adipiscing elit. Suspendisse fermentum diam 
            sed mi finibus iaculis. Vestibulum rutrum non
            velit ut tristique. Etiam scelerisque neque elit,
            rhoncus auctor metus blandit at.`,
            image:'/client-reviews/k-miller.svg'
        },
        {
            title:'Dr. Kamila Brown',
            location: 'Private Practice',
            quote: `Lorem ipsum dolor sit amet, consectetur 
            adipiscing elit. Suspendisse fermentum diam 
            sed mi finibus iaculis. Vestibulum rutrum non
            velit ut tristique. Etiam scelerisque neque elit,
            rhoncus auctor metus blandit at.`,
            image:'/client-reviews/k-brown.svg'
        },
        {
            title:'Dr. Kendra Miller',
            location: 'Kingston Public Hospital',
            quote: `Lorem ipsum dolor sit amet, consectetur 
            adipiscing elit. Suspendisse fermentum diam 
            sed mi finibus iaculis. Vestibulum rutrum non
            velit ut tristique. Etiam scelerisque neque elit,
            rhoncus auctor metus blandit at.`,
            image:'/client-reviews/k-miller.svg'
        },
        {
            title:'Dr. Kamila Brown',
            location: 'Private Practice',
            quote: `Lorem ipsum dolor sit amet, consectetur 
            adipiscing elit. Suspendisse fermentum diam 
            sed mi finibus iaculis. Vestibulum rutrum non
            velit ut tristique. Etiam scelerisque neque elit,
            rhoncus auctor metus blandit at.`,
            image:'/client-reviews/k-brown.svg'
        },
     
    ];

    const [position, setPosition] = useState(0);
    const [canvasWidth, setCanvasWidth] = useState(0);


    // useEffect(() => {
    //     handleResize();
    // });
    const handleResize = () => {
        window.addEventListener('resize', handleResize);
        return window.innerWidth;
        
    };

    const moveRight = () => {
        setPosition(position + 1)
    }

    const moveLeft = () => {
        setPosition(position - 1)
    }
    
    return (
        <Container>
               
            <HeaderContainer>
                <Header>What our clients think</Header>
            </HeaderContainer>
            <div style={{width:"100vw",position:"relative"}}>
                <Carousel
                    className=""
                    slidesPerPage={handleResize() > 1100 ? 2 : 1}
                    arrowRight={<ActiveNavigation onClick={moveRight} src="/client-reviews/active_chevron.svg"/>}
                    arrowLeft={ position > 0 ? <ActiveNavigation style={{left: '0rem', transform: 'rotateY(180deg)'}} onClick={moveLeft} src="/client-reviews/active_chevron.svg"/> :
                        <DisabledNavigation src="/client-reviews/disabled_chevron.svg"/>}
                    addArrowClickHandler

                >
                 
                    
                        {
                            array.map((value, index) => {
                                return (
                                <ReviewContainer>
                                    <VerticalContainer>
                                        <Review>
                                            <Quote src="/icons/quote.svg"/>
                                            <div className="quote">
                                                <p>{value.quote}</p>
                                            </div>
                                        </Review>
                                        <ImageContainer>
                                            <img className="doctor" alt="Doctor" src={value.image} />
                                            <Title>
                                                <p className="title">{value.title}</p>
                                                <p className="location">{value.location}</p>
                                            </Title>
                                        </ImageContainer>
                                    </VerticalContainer>
                                </ReviewContainer>
                                )
                            })
                        }
                   
                   
                </Carousel>
            </div>
            
            <Divider/>
            <NavigationContainer>
                {/* {
                    position > 0 ?
                
                        <ActiveNavigation style={{transform: 'rotateX(180deg)'}} src="/client-reviews/active_chevron.svg"/>
                        :
                        <DisabledNavigation src="/client-reviews/disabled_chevron.svg"/>
                } */}
                
            </NavigationContainer>
        </Container>
    );

}

export default ClientReview;